module.exports = __webpack_public_path__ + "static/media/logo.a483ffc9.svg";